import axios from '../../http_v2'
export default {
    save: params => {
        return axios.post("opservice/marketingCampaign/save", params);
      },
    tree: params => {
        return axios.get("opservice/corp/getAll", params);
      },
    notify: params => {
        return axios.post("opservice/marketingCampaign/ykj/notify", params)
      },
    find: params => {
      return axios.post("opservice/marketingCampaign/find",params)
    }
}
